// @ts-nocheck
import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAdminAuth } from '@/auth/AuthProvider';
import AuthShell, {
  AuthHeaderSwap,
  authInput,
  authLabel,
  authPrimaryButton,
  authErrorBanner,
} from '@/components/Auth/AuthShell';

// Set/reset an admin password from an emailed link (invite or forgot-password).
const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const { resetPassword } = useAdminAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [form, setForm] = useState({ password: '', confirm: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const canSubmit = useMemo(
    () => form.password.length >= 8 && form.password === form.confirm,
    [form],
  );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    if (form.password !== form.confirm) { setErrorMessage('Passwords do not match.'); return; }
    setIsSubmitting(true);
    try {
      const result = await resetPassword(token, form.password);
      const hasOrg = result && result.admin && (result.admin.organizations || []).length > 0;
      navigate(hasOrg ? '/admin/dashboard' : '/setup', { replace: true });
    } catch (err: any) {
      const msg = (err && err.response && err.response.data && err.response.data.error) || (err && err.message) || 'Reset failed.';
      setErrorMessage(String(msg));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell
      headerAction={<AuthHeaderSwap to="/sign-in" label="Sign in" />}
      title={<>Set your <span className="text-ploy-accent-primary-500">password</span></>}
      subtitle="Choose a strong password to finish."
    >
      {!token ? (
        <div className={`${authErrorBanner} mb-0`}>
          Missing or invalid reset link. Request a new one from <Link to="/forgot-password" className="underline">Forgot password</Link>.
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          {errorMessage && <div className={authErrorBanner}>{errorMessage}</div>}
          <label className={authLabel}>New password</label>
          <input
            type="password" value={form.password} onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} required
            className={authInput}
            placeholder="At least 8 characters"
          />
          <label className={`${authLabel} mt-4`}>Confirm password</label>
          <input
            type="password" value={form.confirm} onChange={(e) => setForm((p) => ({ ...p, confirm: e.target.value }))} required
            className={authInput}
            placeholder="Re-enter password"
          />
          <button type="submit" disabled={!canSubmit || isSubmitting} className={`${authPrimaryButton} mt-6`}>
            {isSubmitting ? 'Saving…' : 'Set password'}
          </button>
        </form>
      )}
    </AuthShell>
  );
};

export default ResetPasswordPage;
